import {Theme, useFundamentalContext} from '@hm/fundamental'
import {useEffect} from 'react'

const MAINTAIN_THEME_LIGHT: Theme = 'ThemeLightBlue'

export const FundamentalThemeInitializer = () => {
  const {theme: fundamental} = useFundamentalContext()

  useEffect(() => {
    if (fundamental.currentTheme !== MAINTAIN_THEME_LIGHT) {
      fundamental.updateTheme(MAINTAIN_THEME_LIGHT)
    }
  }, [fundamental])

  return null
}
